import axios from 'axios';

import { setAlert } from '../alert';
import { GET_USERS, GET_USER, UPDATE_USER } from '../types';
import history from '../../history';

// TODO: to clean the code because we are no longer using /api path anymore
const basePath = `${process.env.REACT_APP_API_URL}/api`;

export const getUsers = () => async (dispatch) => {
  try {
    const res = await axios.get(`${basePath}/users`);

    dispatch({
      type:    GET_USERS,
      payload: res.data,
    });
  } catch (err) {
    const error = err.response.data.message;

    if (error) {
      dispatch(setAlert(error, 'danger'));
    }
  }
};

export const getUser = (id) => async (dispatch) => {
  try {
    const res = await axios.get(`${basePath}/users/${id}`);

    dispatch({ type: GET_USER });

    return res.data.user;
  } catch (err) {
    const error = err.response.data.message;

    if (error) {
      dispatch(setAlert(error, 'danger'));
    }
  }
};

export const updateUser = (data, id) => async (dispatch) => {
  const config = {
    headers: {
      'Content-Type': 'application/json',
    },
  };

  const body = JSON.stringify(data);

  try {
    await axios.post(`${basePath}/users/update/${id}`, body, config);

      dispatch({ type: UPDATE_USER });

      dispatch(setAlert('User Updated', 'success'));

      history.push('/');
  } catch (err) {
    const error = err.response.data.message;

    if (error) {
      dispatch(setAlert(error, 'danger'));
    }
  }
};

export const changePassword = (data) => async (dispatch) => {
  const config = {
    headers: {
      'Content-Type': 'application/json',
    },
  };

  const body = JSON.stringify(data);

  try {
    await axios.post(`${basePath}/change-password`, body, config);
    dispatch(setAlert('Password updated!', 'success'));
  } catch (err) {
    const error = err.response.data.message;

    if (error) {
      dispatch(setAlert(error, 'danger'));
    }
  }
};
